"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.matchesRenameRuleSearch = void 0;
const matchesRenameRuleSearch = (rule, searchQuery) => {
    var _a, _b;
    const normalizedQuery = searchQuery.trim().toLowerCase();
    if (!normalizedQuery) {
        return true;
    }
    return (((_a = rule.renamePayeeTo) === null || _a === void 0 ? void 0 : _a.toLowerCase().includes(normalizedQuery)) ||
        ((_b = rule.renamePayeeFrom) === null || _b === void 0 ? void 0 : _b.toLowerCase().includes(normalizedQuery)) ||
        false);
};
exports.matchesRenameRuleSearch = matchesRenameRuleSearch;
